// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asset-card {\n  min-height: 280px;\n  overflow: hidden;\n}[dir] .asset-card {\n  box-shadow: 0px 3.07029390335083px 6.14058780670166px 0px rgba(0, 1, 27, 0.16);\n}\n.asset-card img {\n  width: 100%;\n  height: auto;\n  -o-object-fit: scale-down;\n     object-fit: scale-down;\n  height: 237px;\n  --bg-opacity: 1;\n}\n[dir] .asset-card img {\n  background-color: #F4F4FA;\n  background-color: rgba(244, 244, 250, var(--bg-opacity));\n}\n", ""]);
// Exports
module.exports = exports;
